import { TextField, FormControl, Select, MenuItem } from "@mui/material";
import { useEffect } from "react";

const UseInfoOthers = ({
  isEdit,
  userInfo,
  setUserInfo,
  validateStatus,
  setValidateStatus
}) => {
  const visas = [
    "観光・短期滞在 Tourist Visa",
    "ロングステイ SRVV",
    "特別就学 SSP",
    "学生 9F",
    "就労 Work Visa / 9G",
    "特別労働許可証 SWP",
    "特別永住権 SRRV / SIRV",
    "条約投資家 Treaty Investor Visa",
    "結婚移住 13A / Non-Quota Immigrant Visa",
    "PEZAビザ (47(A)(2))",
    "その他"
  ];

  const getPhoneWithoutCountryCode = (phone) => {
    return phone?.replace(/^(\+81|\+63)/, "") ?? "";
  };

  useEffect(() => {
    if (!isEdit) return;

    const phones = [
      getPhoneWithoutCountryCode(userInfo?.phoneJa),
      getPhoneWithoutCountryCode(userInfo?.phonePh)
    ].filter(Boolean);

    let phoneVal = { valid: true, message: "" };

    if (phones.length === 0) {
      phoneVal.valid = false;
      phoneVal.message =
        "日本またはフィリピンの電話番号を必ず登録してください。";
    } else {
      const invalid = phones.find((p) => {
        const digits = p.replace(/[^\d]/g, "");
        return digits.length < 7 || digits.length > 10;
      });
      if (invalid) {
        phoneVal.valid = false;
        phoneVal.message = "電話番号は7〜10桁の数字で入力してください。";
      }
    }

    setValidateStatus((prev) => ({
      ...prev,
      phone: phoneVal
    }));
  }, [userInfo, isEdit]);

  const phoneHandler = (e, key) => {
    const raw = String(e).trim();
    const digitsOnly = raw.replace(/[^\d]/g, "");
    const formatted = digitsOnly
      ? `${key === "phonePh" ? "+63" : "+81"}${digitsOnly}`
      : "";

    setUserInfo((prev) => {
      const updated = { ...prev, [key]: formatted };

      const phDigits = updated.phonePh?.replace(/[^\d]/g, "") ?? "";
      const jaDigits = updated.phoneJa?.replace(/[^\d]/g, "") ?? "";
      const allDigits = [phDigits, jaDigits].filter(Boolean);

      let val = { valid: true, message: "" };
      if (allDigits.length === 0) {
        val.valid = false;
        val.message =
          "電話番号は日本かフィリピンいずれかの登録が必須です。";
      } else if (!allDigits.every((d) => /^\d{7,10}$/.test(d))) {
        val.valid = false;
        val.message = "電話番号は7〜10桁の数字で入力してください。";
      }

      setValidateStatus((prevVal) => ({ ...prevVal, phone: val }));
      return updated;
    });
  };

  const textCheckHandler = (e, key) => {
    const input = e;
    let val = { valid: true, message: "" };
    const allowedRegex =
      /^[\u3040-\u30FF\u4E00-\u9FFF\uFF10-\uFF19 0-9a-zA-Z\s,\-'.]+$/;

    if (input.length > 100) {
      val.valid = false;
      val.message = "100文字以内で入力してください";
    }
    if (!allowedRegex.test(input) && input.length > 0) {
      val.valid = false;
      val.message = "日本語またはローマ字で入力してください";
    }

    setValidateStatus((prev) => ({
      ...prev,
      [key]: val
    }));
    setUserInfo((prev) => ({ ...prev, [key]: input }));
  };

  return (
    <dl className="dl" style={{ marginBottom: "42px" }}>
      <dt>電話番号{isEdit && <span>※</span>}</dt>
      <dd className="tell">
        {isEdit ? (
          <div>
            <div className="phoneForm">
              <span className="ph">🇵🇭+63</span>
              <TextField
                value={getPhoneWithoutCountryCode(userInfo.phonePh)}
                onChange={(e) => phoneHandler(e.target.value, "phonePh")}
                error={!validateStatus.phone?.valid}
                helperText={validateStatus.phone?.message}
                InputProps={{
                  sx: {
                    "& input": {
                      padding: "8px 16px"
                    }
                  }
                }}
                sx={{ width: "100%" }}
              />
            </div>
            <div className="phoneForm">
              <span>🇯🇵+81</span>
              <TextField
                value={getPhoneWithoutCountryCode(userInfo.phoneJa)}
                onChange={(e) => phoneHandler(e.target.value, "phoneJa")}
                error={!validateStatus.phone?.valid}
                helperText={validateStatus.phone?.message}
                InputProps={{
                  sx: {
                    "& input": {
                      padding: "8px 16px"
                    }
                  }
                }}
                sx={{ width: "100%" }}
              />
            </div>
            <p>
              <small>
                電話番号は日本/フィリピンいずれかの登録が必要です
                <br />
                電話番号は冒頭の０を抜いてご記入ください
              </small>
            </p>
          </div>
        ) : (
          <div className="col">
            {userInfo.phonePh && <span>🇵🇭{userInfo.phonePh}</span>}
            {userInfo.phoneJa && <span>🇯🇵{userInfo.phoneJa}</span>}
          </div>
        )}
      </dd>

      <dt>住所</dt>
      <dd>
        {isEdit ? (
          <TextField
            value={userInfo.address}
            onChange={(e) => textCheckHandler(e.target.value, "address")}
            error={!validateStatus.address?.valid}
            helperText={validateStatus.address?.message}
            InputProps={{
              sx: {
                "& input": {
                  padding: "8px 16px"
                }
              }
            }}
            sx={{ width: "100%" }}
          />
        ) : (
          <div>{userInfo.address}</div>
        )}
      </dd>

      <dt>勤務先</dt>
      <dd>
        {isEdit ? (
          <TextField
            value={userInfo.job}
            onChange={(e) => textCheckHandler(e.target.value, "job")}
            error={!validateStatus.job?.valid}
            helperText={validateStatus.job?.message}
            InputProps={{
              sx: {
                "& input": {
                  padding: "8px 16px"
                }
              }
            }}
            sx={{ width: "100%" }}
          />
        ) : (
          <div>{userInfo.job}</div>
        )}
      </dd>

      <dt>VISAの種類</dt>
      <dd>
        {isEdit ? (
          <FormControl fullWidth>
            <Select
              value={userInfo.visa}
              onChange={(e) =>
                setUserInfo({ ...userInfo, visa: e.target.value })
              }
            >
              {visas.map((item, i) => (
                <MenuItem value={item} key={`item${i}`}>
                  {item}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        ) : (
          <div>{userInfo.visa}</div>
        )}
      </dd>
    </dl>
  );
};

export default UseInfoOthers;
